import { cn } from '@lib/utils';

interface BoxProps {
  children: React.ReactNode;
  className?: string;
}

function Section({ children, className }: BoxProps) {
  const baseClassName = 'flex flex-col gap-y-4 md:gap-y-8';

  return <section className={cn(baseClassName, className)}>{children}</section>;
}

export default Section;
